// FAQ accordion — one item open at a time (clicking the open item closes it).
export function initAccordion(): void {
  document.querySelectorAll<HTMLElement>('[data-accordion]').forEach((root) => {
    const items = Array.from(root.querySelectorAll<HTMLElement>('[data-accordion-item]'));

    items.forEach((item) => {
      const toggle = item.querySelector<HTMLButtonElement>('[data-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((other) => {
          other.classList.remove('is-open');
          other.querySelector('[data-accordion-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}
